/**
 * Get the value type:
 *
 * getType({}) => 'Object'
 * getType([]) => 'Array'
 *
 * @param {*} obj
 * @returns {string}
 */
export function getType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1);
}
/**
 * Compare two version strings:
 *
 * vCompare('4.4', '4.5') => -1
 * vCompare('4.4', '4.4.0') => 0
 * vCompare('4.4', '4.12') => 1
 *
 * @param {string} v1
 * @param {string} v2
 * @returns {number} result 1|-1|0
 */
export function vCompare(v1, v2) {
    var v1Parts = v1.split('.'), v2Parts = v2.split('.');
    while (v1Parts.length < v2Parts.length) {
        v1Parts.push('0');
    }
    while (v2Parts.length < v1Parts.length) {
        v2Parts.push('0');
    }
    for (var i = 0; i < v1Parts.length; i++) {
        if (parseInt(v1Parts[i]) === parseInt(v2Parts[i])) {
            continue;
        }
        else if (parseInt(v1Parts[i]) > parseInt(v2Parts[i])) {
            return 1;
        }
        else if (parseInt(v1Parts[i]) < parseInt(v2Parts[i])) {
            return -1;
        }
        else {
            throw new Error('Oops...Unbelievable error! We can only compare numerically!');
        }
    }
    return 0;
}
function extractVersionFrom(name) {
    var reg = new RegExp("".concat(name, "( |/)([0-9.]*)"));
    var info = navigator.userAgent.toLowerCase().match(reg);
    var version = info ? info.pop().split('.').slice(0, 3).join('.') : '';
    return version;
}
var FRODO_VERSION = typeof DEV !== 'undefined' && !DEV.INAPP
    ? extractVersionFrom('com\\.douban\\.frodo(\\.test)?') || DEV.VERSION
    : extractVersionFrom('com\\.douban\\.frodo(\\.test)?');
var REXXAR_VERSION = extractVersionFrom('rexxar');
// v == cur
var versionIs = function (v, cur) {
    if (getType(v) !== 'String') {
        throw new Error('Version value expected a string');
    }
    return vCompare(v, cur || '999') === 0;
};
// v <= cur
var versionSince = function (v, cur) {
    if (getType(v) !== 'String') {
        throw new Error('Version value expected a string');
    }
    return vCompare(v, cur || '999') !== 1;
};
var frdVersion = {
    __str__: FRODO_VERSION
};
var rxrVersion = {
    __str__: REXXAR_VERSION
};
[frdVersion, rxrVersion].forEach(function (obj) {
    obj.getStr = function () { return obj.__str__; };
    obj.is = function (v) { return versionIs(v, obj.__str__); };
    obj.since = function (v) { return versionSince(v, obj.__str__); };
});
export { frdVersion, rxrVersion };
//# sourceMappingURL=version.js.map